<template>
  <div
    class="wistia_responsive_padding"
    style="padding:56.25% 0 0 0;position:relative;"
  >
    <div
      class="wistia_responsive_wrapper"
      style="height:100%;left:0;position:absolute;top:0;width:100%;"
    >
      <iframe
        src="https://fast.wistia.net/embed/iframe/io2irxqc97?seo=false&videoFoam=true"
        title="EB0103 - Final Video"
        allowtransparency="true"
        frameborder="0"
        scrolling="no"
        class="wistia_embed"
        name="wistia_embed"
        allowfullscreen
        mozallowfullscreen
        webkitallowfullscreen
        oallowfullscreen
        msallowfullscreen
        width="100%"
        height="100%"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'InvestigationEntryWay',

  mounted() {
    this.$loadScript('https://fast.wistia.com/assets/external/E-v1.js')
  },

  destroyed() {
    this.$unloadScript('https://fast.wistia.com/assets/external/E-v1.js')
  },
}
</script>
